import { DataType } from '../types/data_type';
import { EntityAttrKind } from '../types/entity_attr_kind';
import { utils } from '../utils/utils';
/**
 * Represents one entity.
 */
var MetaEntity = /** @class */ (function () {
    /** The default constructor. */
    function MetaEntity(parent) {
        /** Returns false if this entity is read-only */
        this.isEditable = true;
        this.name = "";
        this.caption = "";
        this.description = "";
        this.parent = parent;
        this.attributes = new Array();
        this.subEntities = new Array();
    }
    /**
    * Loads entity from its JSON representation object.
    * @param model The Data Model.
    * @param dto The JSON representation object.
    */
    MetaEntity.prototype.loadFromData = function (model, dto) {
        if (dto) {
            this.id = dto.id;
            this.name = dto.name;
            this.captionPlural = dto.namePlur;
            this.caption = dto.name;
            this.description = dto.desc;
            if (typeof (dto.ied) !== 'undefined')
                this.isEditable = dto.ied;
            this.subEntities = new Array();
            if (dto.ents) {
                for (var i = 0; i < dto.ents.length; i++) {
                    var newEntity = model.createEntity(this);
                    newEntity.loadFromData(model, dto.ents[i]);
                    this.subEntities.push(newEntity);
                }
            }
            this.attributes = new Array();
            if (dto.attrs) {
                for (var i = 0; i < dto.attrs.length; i++) {
                    var newAttr = model.createEntityAttr(this);
                    newAttr.loadFromData(model, dto.attrs[i]);
                    this.attributes.push(newAttr);
                }
            }
        }
    };
    MetaEntity.prototype.scan = function (processAttribute, processEntity) {
        var opts = { stop: false };
        var internalProcessEntity = function (entity) {
            if (processEntity)
                processEntity(entity, opts);
            if (entity.attributes) {
                var attrCount = entity.attributes.length;
                for (var i = 0; (i < attrCount) && !opts.stop; i++) {
                    var attr = entity.attributes[i];
                    if (processAttribute) {
                        processAttribute(attr, opts);
                    }
                    if (opts.stop)
                        return;
                }
            }
            if (entity.subEntities) {
                var subEntityCount = entity.subEntities.length;
                for (var i = 0; (i < subEntityCount) && !opts.stop; i++) {
                    internalProcessEntity(entity.subEntities[i]);
                }
            }
        };
        internalProcessEntity(this);
    };
    MetaEntity.prototype.getFirstPrimaryAttr = function () {
        return this.getPrimaryAttrs()[0];
    };
    MetaEntity.prototype.getPrimaryAttrs = function () {
        return this.attributes.filter(function (attr) { return attr.isPrimaryKey; });
    };
    return MetaEntity;
}());
export { MetaEntity };
var MetaEntityAttr = /** @class */ (function () {
    /** The default constructor. */
    function MetaEntityAttr(entity) {
        this.id = "";
        this.caption = "{Unrecognized attribute}";
        this.dataType = DataType.String;
        this.size = 0;
        this.isPrimaryKey = false;
        this.isForeignKey = false;
        this.isNullable = true;
        this.showOnView = true;
        this.isEditable = true;
        this.showOnCreate = true;
        this.showOnEdit = true;
        this.showInLookup = false;
        this.lookupAttr = "";
        this.expr = "";
        this.entity = entity;
        this.kind = EntityAttrKind.Data;
    }
    /**
     * Loads entity attribute from JSON representation object.
     * @param model The Data Model.
     * @param dto The JSON representation object.
     */
    MetaEntityAttr.prototype.loadFromData = function (model, dto) {
        if (dto) {
            this.id = dto.id;
            this.description = dto.desc;
            this.caption = dto.cptn;
            this.dataType = dto.dtype;
            this.isPrimaryKey = dto.ipk;
            this.isForeignKey = dto.ifk;
            this.size = dto.size;
            this.lookupAttr = dto.lattr;
            this.lookupEntity = dto.lent;
            this.dataAttr = dto.dattr;
            this.lookupDataAttr = dto.ldattr;
            var isDataType = utils.getDateDataTypes().indexOf(this.dataType);
            this.defaultValue = dto.defVal && isDataType ? new Date(dto.defVal) : dto.defVal;
            this.isNullable = utils.getIfDefined(dto.nul, this.isNullable);
            this.isEditable = utils.getIfDefined(dto.ied, this.isEditable);
            this.showOnView = utils.getIfDefined(dto.ivis || dto.sov, this.showOnView);
            this.showOnCreate = utils.getIfDefined(dto.soc, this.showOnCreate);
            this.showOnEdit = utils.getIfDefined(dto.soe, this.showOnEdit);
            this.showInLookup = utils.getIfDefined(dto.sil, this.showInLookup);
            this.kind = dto.kind;
            this.displayFormat = dto.dfmt;
            if (dto.udata)
                this.userData = dto.udata;
            if (dto.edtr) {
                this.defaultEditor = model.getEditorById(dto.edtr) || model.createValueEditor();
            }
        }
    };
    return MetaEntityAttr;
}());
export { MetaEntityAttr };
//# sourceMappingURL=meta_entity.js.map